import React from 'react';

/**
 * レイアウトコンポーネントをルート要素としてレンダリングする。
 * レイアウト内では useAuth() を使って認証情報を取得する。
 */
type Props = {
  layout: React.FC;
};

const AuthenticatedLayoutRoute: React.FC<Props> = ({ layout: Layout }) => {
  return <Layout />;
};

export default AuthenticatedLayoutRoute;
